// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";

function Editor({ onChange, editorLoaded, name, value }) {
  const editorRef = useRef({});
  const [editorInstance, setEditorInstance] = useState(null);

  useEffect(() => {
    const loadEditor = async () => {
      const { CKEditor } = await import("@ckeditor/ckeditor5-react");
      const ClassicEditor = await import("@ckeditor/ckeditor5-build-classic");
      editorRef.current = { CKEditor, ClassicEditor };
      setEditorInstance({ CKEditor, ClassicEditor });
    };
    loadEditor();
  }, []);

  if (!editorInstance || !editorLoaded) {
    return <div>Editor loading...</div>;
  }

  const { CKEditor, ClassicEditor } = editorInstance;

  return (
    <div>
      <CKEditor
        name={name}
        editor={ClassicEditor.default || ClassicEditor}
        data={value || ""}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </div>
  );
}

export default Editor;
